<template>
  <div>
    <main-search-bar @query="handleQuery"></main-search-bar>

    <a-table
      rowKey="id"
      style="overflow:auto"
      :loading="loading"
      :dataSource="userList"
      :pagination="false"
      class="table">
      <a-table-column
        title="UID"
        dataIndex="id"
      />
      <a-table-column
        title="姓名"
        dataIndex="username"
        width="200px"
      />
      <a-table-column
        title="手机号"
        dataIndex="phone"
      ><template slot-scope="phone">
        <span>{{ filterMobile(phone) }}</span>
      </template>
      </a-table-column>
      <a-table-column
        title="所属事业部"
        dataIndex="bussdep"
      />
      <a-table-column
        title="申请时间"
        dataIndex="appleytime"
      />
      <a-table-column
        title="状态"
        dataIndex="status"
      ><template slot-scope="status">
        <span>{{ filterStatus(status) }}</span>
      </template>
      </a-table-column>
      <a-table-column
        title="备注"
        dataIndex="remark"
      />
      <a-table-column
        title="操作"
      ><template slot-scope="userid">
        <a v-show="userid.status == 'apply'" @click="pass(userid.id)">审核通过&nbsp;</a>
        <a v-show="userid.status == 'apply'" @click="reject(userid.id)">审核拒绝&nbsp;</a>
        <a v-show="userid.status == 'pass'" @click="modifyPass(userid.id)">修改密码&nbsp;</a>
        <a-popconfirm title="确认注销该账号？(主账号注销，不影响子账号使用)" @confirm="deleteAccout(userid.id)">
          <a v-show="userid.status == 'pass'" >注销账号</a>
        </a-popconfirm>
        <span v-show="userid.status == 'del'">已注销</span>
        <span v-show="userid.status == 'deny'">已拒绝</span>
      </template>
      </a-table-column>
    </a-table>
    <a-modal
      title="审核拒绝"
      width="400px"
      @ok="handleOk"
      @cancel="visible=false"
      :visible="visible">
      <a-textarea placeholder="请输入..." v-model="rejectReason" :rows="4"/>
    </a-modal>
    <a-modal
      title="修改密码"
      width="400px"
      @ok="handleOk1"
      @cancel="visible1=false"
      :visible="visible1">
      <a-form-item
        label="输入新密码"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }">
        <a-input placeholder="输入新密码" v-model="newPass"/>
      </a-form-item>
      <br>
      <a-form-item
        label="再次输入密码"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }">
        <a-input placeholder="再次输入密码" v-model="renewPass"/>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
  import { editAccount, getMainList } from '@/api/account'
  import { resetpasswd } from '@/api/common'

  import MainSearchBar from './mainSearchBar.vue'

  export default {
    name: 'MainManage',
    components: {
      MainSearchBar
    },
    data() {
      return {
        loading:false,
        rejectReason:'',
        visible:false,
        visible1:false,
        newPass:'',
        chooseId:0,
        renewPass:'',
        userList:[]
      }
    },
    created() {

    },
    mounted() {
      this.getList()
    },
    methods: {
      handleQuery(searchData){
        this.getList(searchData)
      },
      filterStatus(item){
        if (item=='pass'){
          return '通过'
        } else if (item=='deny'){
          return '拒绝'
        } else if (item=='del'){
          return '注销'
        } else if (item=='apply'){
          return '待审核'
        }
      },
      filterMobile(mobile){
        mobile = mobile+''
        return mobile.substring(0,3)+'****'+mobile.substring(7,mobile.length)
      },
      getList(params){
        getMainList(params).then(res=>{
          if (res.code==1){
            this.userList = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleOk(){
        if (!this.rejectReason){
          this.$message.error('拒绝理由不能为空')
          return
        }
        editAccount({type:'deny',msg:this.rejectReason,uid:this.chooseId}).then(res=>{
          if (res.code==1){
            this.$message.success('操作成功')
            this.getList()
            this.visible = false
          }
        })
      },
      handleOk1(){
        if (!this.newPass){
          this.$message.error('密码不能为空')
          return
        }
        if (this.newPass!=this.renewPass){
          this.$message.error('密码不一致')
          return
        }
        resetpasswd({password:this.newPass,uid:this.chooseId}).then(res=>{
          if (res.code==1){
            this.$message.success('修改成功')
            this.visible1 = false
          }
        })
      },
      modifyPass(id){
        this.chooseId = id
        this.renewPass = ''
        this.newPass = ''
        this.visible1 = true
      },
      pass(id){
        editAccount({type:'pass',uid:id}).then(res=>{
          if (res.code==1){
            this.$message.success('操作成功')
            this.getList()
          }
        })
      },
      reject(id){
        this.chooseId = id
        this.rejectReason = ''
        this.visible = true
      },
      deleteAccout(id){
        editAccount({type:'del',uid:id}).then(res=>{
          if (res.code==1){
            this.$message.success('操作成功')
            this.getList()
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
